import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./authSlice";
import pageSlice from "./pageSlice";
import companyConfSlice from "./companyConfSlice";
import generalRegSlice from "./generalRegSlice";

export default configureStore({
    reducer: {
        auth: authSlice,
        page: pageSlice,
        companyConf: companyConfSlice,
        generalReg: generalRegSlice
    }
});